// The crypto Fear & Greed index (CoinMarketCap) for the Overview hero. It is the
// same value the public «Рынок сегодня» page shows: the site's market server
// (server/index.js → GET /api/sentiment on the site's own origin) reads it from
// its cached snapshot, so opening the Overview never calls the source itself.
// Public market data: the same for every plan. No value → no index, never a guess.
import { z } from 'zod';

const LEVELS = ['extreme_fear', 'fear', 'neutral', 'greed', 'extreme_greed'] as const;
export const MarketMoodSchema = z.object({
  available: z.boolean(),
  value: z.number().min(0).max(100).nullable(),
  level: z.enum(LEVELS).nullable(),
  previousValue: z.number().nullable(),
  updatedAt: z.string().nullable(),
  stale: z.boolean(),
  source: z.string(),
  sourceUrl: z.string(),
});
export type MarketMood = z.infer<typeof MarketMoodSchema>;

export async function fetchMarketMood(): Promise<MarketMood> {
  const r = await fetch('/api/sentiment', { headers: { accept: 'application/json' } });
  if (!r.ok) throw new Error(`sentiment ${r.status}`);
  return MarketMoodSchema.parse(await r.json());
}
